<script>
    import Card from './Card.svelte';
    import PurchasePaddle from './PurchasePaddle.svelte';
    import H2 from './H2.svelte';
    import { goto } from '$app/navigation';
    import ProductIcon from './ProductIcon.svelte';

    /** @type {Bundle} */
    export let bundle;

    /** @type {Course|undefined} */
    export let course = undefined;

    /** @type {Worksheet|undefined} */
    export let worksheet = undefined;

    let className = '';
    export { className as class };

    const items_purchased = bundle.items.filter((i) => i.purchased).length;

    const items_total = bundle.items.length;

    export let feature = 'bundle';
</script>

<Card
    class="{className} flex flex-col"
    clickable
    on:click={() => goto(`/bundles/${bundle.slug}`)}
>
    <H2>
        <a href="/bundles/{bundle.slug}" class="link">
            {#if course}
                Buy {course.title} in {bundle.title}
            {:else if worksheet}
                Buy {worksheet.title} in {bundle.title}
            {:else}
                {bundle.title}
            {/if}
        </a>
    </H2>

    <div class="flex-1">
        {#if bundle.lead}
            <p class="my-2">{@html bundle.lead}</p>
        {/if}

        {#if bundle.purchased}
            <p class="my-2">Collection complete!</p>
        {:else if items_purchased}
            <p class="my-2">
                {items_purchased} of {items_total} items are already in your library.
            </p>
        {/if}

        <p class="my-2">
            <em class="accent">Includes {items_total} items:</em>
            {bundle.items.map((c) => c.title).join(', ')}.
        </p>
    </div>

    <div
        class="flex flex-nowrap justify-around md:justify-start bg-black/40 -mx-4 px-4 py-4 my-5"
    >
        {#each bundle.items as item, index}
            <ProductIcon
                product={item}
                class="-ml-16 first:ml-0 md:ml-2"
                style="z-index: {items_total - index};"
            />
        {/each}
    </div>

    <div class="flex flex-col sm:flex-row justify-end items-stretch gap-2">
        <a
            href="/bundles/{bundle.slug}"
            class="btn btn-lg btn-outline flex items-center justify-center my-0.5"
            >Bundle info</a
        >

        {#if !items_purchased}
            <div
                class="flex gap-4 bg-black px-2 sm:px-4 py-2 rounded-lg items-center justify-center"
            >
                <span class="text-2xl font-bold border-r-2 border-white/20 pr-4"
                    >{@html bundle.discount_percent}</span
                >
                <PurchasePaddle
                    product={bundle}
                    cta="Buy Bundle"
                    style="small"
                    stopPropagation
                    {feature}
                />
            </div>
        {/if}
    </div>
</Card>
